/**
 * @file
 * Check if project running in dev mode.
 */

import process from 'process';

export default !process?.env?.NODE_ENV || process?.env?.NODE_ENV === 'development';
